import './Sidebar.css';
import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from "react-router-dom";
import AddIcon from '../assets/icons8-add-30.png';
import CompletedIcon from '../pages/completed/completed.png';
import DashboardIcon from '../assets/transaction-list.png';
import Avatar from "./Avatar";
import { useAuthContext } from "../hooks/useAuthContext";

const Sidebar = () => {
    const { user } = useAuthContext();
    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const location = useLocation();

    // Close sidebar when route changes (mobile)
    useEffect(() => {
        setIsMobileOpen(false);
    }, [location]);

    // Close sidebar when clicking outside (mobile)
    const handleOverlayClick = () => {
        setIsMobileOpen(false);
    };

    const toggleMobileMenu = () => {
        setIsMobileOpen(!isMobileOpen);
    };

    return (
        <>
            {/* Hamburger Menu Button */}
            <button 
                className={`hamburger-btn ${isMobileOpen ? 'open' : ''}`}
                onClick={toggleMobileMenu}
                aria-label="Toggle menu"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>

            {/* Overlay for mobile */}
            <div 
                className={`sidebar-overlay ${isMobileOpen ? 'show' : ''}`}
                onClick={handleOverlayClick}
            ></div>

            {/* Sidebar */}
            <div className={`sidebar ${isMobileOpen ? 'mobile-open' : ''}`}>
                <div className="sidebar-content">
                    <div className="user">
                        <Avatar src={user.photoURL}/>
                        <p>Hey {user.displayName}</p>
                    </div>
                    <nav className="links">
                        <ul>
                            <li>
                                <NavLink end to='/'>
                                    <img src={DashboardIcon} alt="Dashboard icon"/>
                                    <span>Dashboard</span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to='/create'>
                                    <img src={AddIcon} alt="Add document"/>
                                    <span>New Project</span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to='/future-assignments'>
                                    <img src={CompletedIcon} alt="View not published assignments"/>
                                    <span className='smallSidebar'>Future Assignments</span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to='/needs-graded'>
                                    <img src={CompletedIcon} alt="Needs graded"/>
                                    <span className='smallSidebar'>Needs Graded</span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to='/completed'>
                                    <img src={CompletedIcon} alt="View Completed Documents"/>
                                    <span className='smallSidebar'>Completed</span>
                                </NavLink>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </>
    );
};

export default Sidebar;